/* YORU Y2K: Japanese layer */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var SUBS = {
    'just dropped': '新着アイテム',
    'new arrivals': '新作',
    'collections': 'コレクション',
    'products': '全商品',
    'tops': 'トップス',
    'bottoms': 'ボトムス',
    'accessories': 'アクセサリー',
    'contact': 'お問い合わせ',
    'sizes': 'サイズ表'
  };
  var FALLBACK = 'ヨル ストリート';

  function jpSubtitles() {
    document.querySelectorAll('.title, .main-page-title, .collection-hero__title').forEach(function (el) {
      if (el.querySelector('.y2k-jp-sub')) return;
      var key = (el.textContent || '').trim().toLowerCase();
      var sub = document.createElement('span');
      sub.className = 'y2k-jp-sub';
      sub.setAttribute('lang', 'ja');
      sub.textContent = SUBS[key] || FALLBACK;
      el.appendChild(sub);
    });
  }

  function kawaiiTags() {
    document.querySelectorAll('.card-wrapper .card__inner').forEach(function (el) {
      if (el.querySelector('.y2k-kawaii')) return;
      var t = document.createElement('span');
      t.className = 'y2k-kawaii';
      t.setAttribute('aria-hidden', 'true');
      t.textContent = '✩ かわいい ✩';
      el.appendChild(t);
    });
  }

  function jpMarquee() {
    var track = document.querySelector('.y2k-marquee__track');
    if (!track || track.dataset.jp) return;
    track.dataset.jp = '1';
    var jp = ['予約受付中', '夜 ヨル', '新作入荷', '東京 ストリート'];
    track.querySelectorAll('span').forEach(function (s, i) {
      if (i % 2 === 1) s.textContent = '✦ ' + jp[Math.floor(i / 2) % jp.length];
    });
  }

  function heroBits() {
    var hero = document.querySelector('.slideshow .slideshow__slide, .slideshow .banner');
    if (!hero || hero.querySelector('.y2k-hero-kanji')) return;
    var k = document.createElement('div');
    k.className = 'y2k-hero-kanji';
    k.setAttribute('aria-hidden', 'true');
    k.textContent = '夜の街';
    hero.appendChild(k);
    var st = document.createElement('div');
    st.className = 'y2k-sticker';
    st.setAttribute('aria-hidden', 'true');
    st.innerHTML = '<span>新作!<small>NEW DROP</small></span>';
    hero.appendChild(st);
  }

  function rail() {
    if (document.querySelector('.y2k-rail')) return;
    var r = document.createElement('div');
    r.className = 'y2k-rail';
    r.setAttribute('aria-hidden', 'true');
    r.innerHTML = '<b>夜</b> YORU ✦ ジャパニーズストリート ✦ <b>Y2K</b>';
    document.body.appendChild(r);
  }

  function petals() {
    if (reduceMotion || document.querySelector('.y2k-petal')) return;
    var n = window.innerWidth < 750 ? 6 : 12;
    for (var i = 0; i < n; i++) {
      var p = document.createElement('span');
      p.className = 'y2k-petal';
      p.setAttribute('aria-hidden', 'true');
      p.style.left = Math.random() * 100 + 'vw';
      p.style.animationDuration = (9 + Math.random() * 8).toFixed(1) + 's';
      p.style.animationDelay = (-Math.random() * 15).toFixed(1) + 's';
      var s = 8 + Math.random() * 8;
      p.style.width = s + 'px'; p.style.height = s + 'px';
      document.body.appendChild(p);
    }
  }

  function init() { jpSubtitles(); kawaiiTags(); heroBits(); rail(); petals(); setTimeout(jpMarquee, 50); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { jpSubtitles(); kawaiiTags(); heroBits(); });
})();
